<template>
  <div class="sticky-ask-us-btn">
    <tk-ask-us-dialog v-model="showAskUsDialog" topic="request" />

    <base-card color="primary" class="px-2 py-3 pointer-cursor" @click="showAskUsDialog = true">
      <v-layout column justify-center align-center text-xs-center>
        <v-flex mb-1>
          <v-icon color="white" size="19">fas fa-paper-plane</v-icon>
        </v-flex>
        <v-flex>
          <div class="text font-weight-medium">{{ $t('ARTWORK.ASK_US') }}</div>
        </v-flex>
      </v-layout>
    </base-card>
  </div>
</template>

<script>
export default {
  components: {
    TkAskUsDialog: () => import("@/components/core/TkAskUsDialog")
  },

  data: () => ({
    showAskUsDialog: false
  })
};
</script>

<style lang="scss">
.sticky-ask-us-btn {
  position: fixed;
  position: fixed;
  right: 0px;
  z-index: 9;
  top: 50%;
  transform: translateY(-50%);

  .text {
    color: #fff;
    width: 50px;
  }
}
</style>
